
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8 .125C3.669.125.125 3.669.125 8c0 4.331 3.544 7.875 7.875 7.875 4.331 0 7.875-3.544 7.875-7.875C15.875 3.669 12.331.125 8 .125zm2.796 10.867L7.583 9.017a.776.776 0 01-.378-.67V4.654a.607.607 0 01.598-.59c.323 0 .59.267.59.59v3.505l3.025 1.819a.603.603 0 01.205.826.606.606 0 01-.827.19z","fill":"#ADA3BF"}})])
          )
        }
      }
    